import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  padding: 40px;
`;

const Title = styled.h1`
  color: #3B6255;
  margin-bottom: 20px;
  text-align: center;
`;

const Message = styled.p`
  font-size: 16px;
  text-align: center;
  max-width: 600px;
  line-height: 1.5;
  color: #333;
`;

const ErrorMessage = styled(Message)`
  color: #AE0505;
`;

const SuccessMessage = styled(Message)`
  color: #3B6255;
`;

const LoadingSpinner = styled.div`
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3B6255;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const EmailVerification: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');
  const token = searchParams.get('token');

  useEffect(() => {
    const verifyEmail = async () => {
      if (!token) {
        setStatus('error');
        setMessage('Відсутній токен верифікації');
        return;
      }

      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_API_URL}/auth/verify-email?token=${token}`
        );
        const data = await response.json();

        if (response.ok) {
          setStatus('success');
          setMessage(data.message);
        } else {
          setStatus('error');
          setMessage(data.error || 'Помилка верифікації');
        }
      } catch (error) {
        setStatus('error');
        setMessage('Помилка мережі');
      }
    };

    verifyEmail();
  }, [token]);

  return (
    <Container>
      {status === 'loading' && (
        <>
          <LoadingSpinner />
          <Title>Підтвердження email...</Title>
          <Message>Будь ласка, зачекайте, поки ми підтверджуємо вашу email адресу.</Message>
        </>
      )}

      {status === 'success' && (
        <>
          <Title>Email підтверджено!</Title>
          <SuccessMessage>{message}</SuccessMessage>
        </>
      )}

      {status === 'error' && (
        <>
          <Title>Помилка підтвердження</Title>
          <ErrorMessage>{message}</ErrorMessage>
        </>
      )}
    </Container>
  );
};

export default EmailVerification;